import React, { useEffect, useState } from "react";
import PageHeader from "../pages/PageHeader";
import { Helmet } from "react-helmet";
import AboutSection from "../pages/AboutSection";
import ServiceSection from "../pages/ServiceSection";
import AboutUsProject from "./AboutUsProject";
import MarqueeSection from "../pages/MarqueeSection";
import TeamMember from "./TeamMember";
const AboutUs = () => {
  useEffect(() => {
      window.scrollTo(0, 0); // Scroll to top when pathname changes
    },);

  return (
    <div>
<Helmet>
  {/* Basic Meta Tags */}
  <meta charSet="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />

  <title>About Us - AppNexts | Your Trusted Partner for Digital Solutions & Innovation</title>

  <meta
    name="description"
    content="Learn about AppNexts, a leader in digital solutions offering app development, web design, UI/UX design, digital marketing, SEO, data analysis, and more. Our mission is to empower businesses with innovative technology."
  />
  <meta
    name="keywords"
    content="About AppNexts, App Development, Web Development Services, UI/UX Design, Digital Marketing Agency, SEO Services, IT Solutions, Custom Software Development, Data Analysis, Graphic Design, Video Editing"
  />
  <meta name="robots" content="index, follow" />
  <meta httpEquiv="Content-Language" content="en" />
  <meta property="og:locale" content="en_US" />

  {/* Canonical URL */}
  <link rel="canonical" href="https://www.appnexts.com/about-us" />

  {/* Open Graph Tags */}
  <meta property="og:title" content="About Us - AppNexts | Your Trusted Partner for Digital Solutions & Innovation" />
  <meta
    property="og:description"
    content="Discover the mission, values, and expertise behind AppNexts. We specialize in app development, web design, SEO, and innovative digital solutions that drive business success."
  />
  <meta property="og:image" content="https://www.appnexts.com/seo_image/about_us_seo.png" />
  <meta property="og:url" content="https://www.appnexts.com/about-us" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AppNexts" />

  {/* Twitter Card Tags */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="About Us - AppNexts | Your Trusted Partner for Digital Solutions & Innovation" />
  <meta
    name="twitter:description"
    content="Discover the mission and values of AppNexts. We provide digital solutions in app development, web design, SEO, and more to help businesses succeed."
  />
  <meta name="twitter:image" content="https://www.appnexts.com/seo_image/about_us_seo.png" />

  {/* Structured Data (JSON-LD) */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "About Us - AppNexts",
      "description": "AppNexts is a leading provider of digital solutions specializing in app development, web design, SEO, and custom IT solutions to help businesses grow.",
      "url": "https://www.appnexts.com/about-us",
      "image": {
        "@type": "ImageObject",
        "url": "https://www.appnexts.com/seo_image/about_us_seo.png",
        "width": 1200,
        "height": 630
      },
      "publisher": {
        "@type": "Organization",
        "name": "AppNexts",
        "url": "https://www.appnexts.com",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.appnexts.com/seo_image/appnexts.png"
        }
      },
      "sameAs": [
        "https://www.facebook.com/people/Appnexts/61568551576819",
        "https://www.linkedin.com/company/appnexts",
        "https://www.youtube.com/@AppNexts"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+923092018872",
        "email": "contact@appnexts.com",
        "contactType": "Customer Service",
        "areaServed": ["PK", "US", "IN"],
        "availableLanguage": ["English", "Urdu"]
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "M10 Mezzanine Floor, Siddiq Trade Center, Main Boulevard Gulberg Block H, Gulberg 2",
        "addressLocality": "Lahore",
        "addressRegion": "Punjab",
        "postalCode": "54000",
        "addressCountry": "PK"
      }
    })}
  </script>
</Helmet>


  <PageHeader title="About Us" breadcrumb={[{ label: "Home", path: "/" },{ label: "About Us" }]}/>

<div>

{/* Hero Section */}
<AboutSection/>
<ServiceSection/>
<AboutUsProject/>
<MarqueeSection/>
<TeamMember/>
</div>
    </div>
  );
};

export default AboutUs;
